import $ from 'jquery'
import 'jquery.marquee'

const footerMarquee = () => {
  // @ts-expect-error Marquee is a legacy plugin with no types
  $('.js-footer-marquee').marquee('destroy')

  if (window.innerWidth > 1023) {
    const marqueeOptions = {
      //duration in milliseconds of the marquee
      duration: 30000,
      //gap in pixels between the tickers
      gap: 0,
      //time in milliseconds before the marquee will start animating
      delayBeforeStart: 0,
      //'left' or 'right'
      direction: 'left',
      //true or false - should the marquee be duplicated to show an effect of continues flow
      duplicated: true,
      startVisible: true,
      pauseOnHover: true
    } as const

    // @ts-expect-error Marquee is a legacy plugin with no types
    $('.js-footer-marquee').marquee(marqueeOptions)
  }
}

export const init = async function (): Promise<void> {
  footerMarquee()

  // TODO Throttle resize listener
  $(window).on('resize', function () {
    footerMarquee()
  })
}
